import React from "react";

const NotFound = () => {
  return <h1 style={{ marginTop: "25px" }}>404 page not found</h1>;
};

export default NotFound;
